import React from 'react';

// Rodapé do INEP. Tudo vem de inep_config/geral → rodape (editável em Personalização).
export const RODAPE_PADRAO = {
  whatsapp: '+5521997462390',
  linkedin: '',
  youtube: '',
  instagram: '',
  facebook: '',
  atendimento: 'De segunda à sexta de 8 às 17 horas',
  telefone: '+5521997462390',
  emailContato: '',
  cnpj: '28.667.694/0001-34',
  paginas: [
    { titulo: 'Política de Privacidade', url: '' },
    { titulo: 'Configurações e Suporte', url: '' },
  ],
};

const ICONES = {
  whatsapp: (
    <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.2a.4.4 0 0 0 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 2.9 2.9 0 0 0-.9 2.2 5 5 0 0 0 1.1 2.7 11.6 11.6 0 0 0 4.4 3.9c1.6.7 2.3.8 3.1.6a2.7 2.7 0 0 0 1.8-1.2 2.2 2.2 0 0 0 .1-1.3c0-.1-.2-.2-.4-.3Z" /></svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true"><path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.7h.1a4.2 4.2 0 0 1 3.8-2c4 0 4.8 2.7 4.8 6.1V21h-4v-5.4c0-1.3 0-3-1.8-3s-2.1 1.4-2.1 2.9V21h-4V9Z" /></svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor" aria-hidden="true"><path d="M23 7.2a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.9.5A3 3 0 0 0 1 7.2 31 31 0 0 0 .5 12 31 31 0 0 0 1 16.8a3 3 0 0 0 2.1 2.1c1.9.5 8.9.5 8.9.5s7 0 8.9-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 23.5 12 31 31 0 0 0 23 7.2ZM9.8 15V9l5.2 3-5.2 3Z" /></svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" /></svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true"><path d="M24 12a12 12 0 1 0-13.9 11.9v-8.4H7.1V12h3V9.4c0-3 1.8-4.7 4.5-4.7 1.3 0 2.7.2 2.7.2v2.9h-1.5c-1.5 0-2 .9-2 1.9V12h3.4l-.5 3.5h-2.9v8.4A12 12 0 0 0 24 12Z" /></svg>
  ),
};

function linkRede(rede, valor) {
  if (!valor) return '';
  if (rede === 'whatsapp') return `https://wa.me/${String(valor).replace(/\D/g, '')}`;
  return /^https?:\/\//i.test(valor) ? valor : `https://${valor}`;
}

export default function InepRodape({ config }) {
  const r = { ...RODAPE_PADRAO, ...(config?.rodape || {}) };
  const redes = ['whatsapp', 'linkedin', 'youtube', 'instagram', 'facebook'].filter(k => r[k]);
  const paginas = (r.paginas || []).filter(p => p.titulo);
  return (
    <footer className="inep-rodape">
      {redes.length > 0 && (
        <div className="inep-rodape-redes" style={{ gridTemplateColumns: `repeat(${redes.length}, 1fr)` }}>
          {redes.map(k => (
            <a key={k} href={linkRede(k, r[k])} target="_blank" rel="noopener noreferrer" title={k}>{ICONES[k]}</a>
          ))}
        </div>
      )}
      <div className="inep-rodape-info">
        <div>
          <h4>Atendimento</h4>
          {r.atendimento && <p>{r.atendimento}</p>}
          {r.telefone && <p><a href={linkRede('whatsapp', r.telefone)} target="_blank" rel="noopener noreferrer">📞 {r.telefone}</a></p>}
          {r.emailContato && <p><a href={`mailto:${r.emailContato}`}>✉ Fale Conosco</a></p>}
          {r.cnpj && <p>CNPJ: {r.cnpj}</p>}
        </div>
        {paginas.length > 0 && (
          <div>
            <h4>Páginas</h4>
            <div className="inep-rodape-paginas">
              {paginas.map((p, i) => p.url
                ? <a key={i} href={p.url} target="_blank" rel="noopener noreferrer">{p.titulo}</a>
                : <span key={i}>{p.titulo}</span>)}
            </div>
          </div>
        )}
      </div>
    </footer>
  );
}
